// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KRmr","largestCol":"styles_largestCol__11SHQ","smallestCol":"styles_smallestCol__1VdUQ"};